import { type FC, type ReactNode } from 'react';

import { UrqlGraphQlProvider } from './UrqlGraphQlProvider';
import { UrqlLtiProvider } from './UrqlLtiProvider';

export interface UrqlProviderProps {
  readonly children: ReactNode;
  readonly isLti: boolean;
}

export const UrqlProvider: FC<UrqlProviderProps> = ({ children, isLti }) => {
  if (isLti) {
    return <UrqlLtiProvider>{children}</UrqlLtiProvider>;
  }
  return <UrqlGraphQlProvider>{children}</UrqlGraphQlProvider>;
};
